import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

import { useAuthUser } from '@/modules/Auth'

export const useNearbyFacilities = (options?: SWRConfiguration) => {
  const client = useGyymClient()
  const { isVerified } = useAuthUser()

  return useGyymSWR(
    isVerified ? client.user.facilities.listByNearbyRegisteredAddress : null,
    options,
  )
}
